"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _GroupedProducts = require("./GroupedProducts");
Object.keys(_GroupedProducts).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _GroupedProducts[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _GroupedProducts[key];
    }
  });
});
